import { eventBus } from '@/main'
import Store from '@/store'

export default (_axios) => {
  _axios.interceptors.request.use(
    async function (config) {
      config.headers.Authorization = `Bearer ${Store.getters.token || null}`
      eventBus.$emit('APP_LOADING_START')
      return config
    },
    function (error) {
      eventBus.$emit('APP_LOADING_END')
      return Promise.reject(error)
    }
  )

  _axios.interceptors.response.use(
    function (response) {
      eventBus.$emit('APP_LOADING_END')
      return response
    },
    function (error) {
      eventBus.$emit('APP_LOADING_END')
      return Promise.reject(error)
    }
  )
}
